import { useMutation } from "@tanstack/react-query";
import { createFloorPlanMemoDiagram } from "~/_legacy/apis/create-floor-plan-memo-diagram";
import { isNullish } from "~/_legacy/utils/compare";

export const CREATE_FLOOR_PLAN_MEMO_DIAGRAM_MUTATION_KEY = "createFloorPlanMemoDiagram";

export function useCreateFloorPlanMemoDiagram({
  branchUid,
  branchVersionId,
}: {
  branchUid?: string;
  branchVersionId?: number;
}) {
  const { mutateAsync } = useMutation({
    mutationKey: [CREATE_FLOOR_PLAN_MEMO_DIAGRAM_MUTATION_KEY, branchUid, branchVersionId],
    mutationFn: ({
      floorPlanId,
      coordinates,
      style,
    }: {
      floorPlanId: number;
      coordinates: { x: number; y: number }[];
      style: { fill?: string; borderColor?: string; opacity: number };
    }) => {
      if (isNullish(branchUid)) {
        throw new Error("Branch uid가 필요합니다.");
      }
      return createFloorPlanMemoDiagram({
        branchUid,
        branchVersionId,
        floorPlanId,
        coordinates,
        style,
      });
    },
  });

  return {
    createFloorPlanMemoDiagram: mutateAsync,
  };
}
